import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { motion } from "framer-motion";
import { Footer } from "@/components/Footer";

export default function LegalPage({ doc }) {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = `${doc.title} | Gold Media Studio`;
  }, [doc]);

  return (
    <div className="bg-[#050505] text-[#fafafa] min-h-screen">
      <header className="border-b border-white/10">
        <div className="max-w-screen-2xl mx-auto px-6 sm:px-10 h-20 flex items-center justify-between">
          <Link to="/" data-testid="legal-logo" aria-label="Gold Media Studio">
            <img src="/logo.png" alt="Gold Media Studio" className="h-11 w-auto" />
          </Link>
          <Link
            to="/"
            data-testid="legal-back"
            className="flex items-center gap-2 font-display uppercase tracking-[0.22em] text-[0.72rem] text-[#a1a1aa] hover:text-[#d4c4a8] transition-colors"
          >
            <ArrowLeft size={16} strokeWidth={1.5} /> Zurück
          </Link>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 sm:px-10 py-24 sm:py-32">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        >
          <p className="label mb-6" data-testid="legal-subtitle">{doc.subtitle}</p>
          <h1 className="font-serif font-light text-5xl sm:text-6xl lg:text-7xl tracking-tight uppercase leading-[0.98]" data-testid="legal-title">
            {doc.title}
          </h1>
        </motion.div>

        <div className="mt-16 space-y-12">
          {doc.blocks.map((b, i) => (
            <section key={i} data-testid={`legal-block-${i}`}>
              {b.title && (
                <h2 className="font-display uppercase tracking-[0.14em] text-lg text-[#d4c4a8] mb-4">{b.title}</h2>
              )}
              {b.body?.map((p, j) => (
                <p key={j} className="font-body text-[#a1a1aa] leading-relaxed mb-3">{p}</p>
              ))}
              {b.bullets && (
                <ul className="mt-2 mb-3 space-y-2">
                  {b.bullets.map((li, k) => (
                    <li key={k} className="flex items-start gap-3 font-body text-[#a1a1aa]">
                      <span className="text-[#d4c4a8] text-xs mt-1.5">✦</span> {li}
                    </li>
                  ))}
                </ul>
              )}
              {b.after?.map((p, j) => (
                <p key={j} className="font-body text-[#a1a1aa] leading-relaxed mb-3">{p}</p>
              ))}
            </section>
          ))}
        </div>
      </main>

      <Footer />
    </div>
  );
}
